import Icon from "tds/icon";

export default class extends Icon {}
